module.exports = __webpack_public_path__ + "img/cafebazaar.ee3fa55d.svg";